import { StoreSelectBarVariantEnum } from "@repo/core/components/layout/Scaffolds/StoreSelectScaffold/types";

export const selectStoreBarStyleByVariant = {
  [StoreSelectBarVariantEnum.LIGHT]: {
    bg: "$backgroundDark100",
    iconColor: "$primary600",
    chevronColor: "$secondary700",
    textColor: "$secondary700"
  },
  [StoreSelectBarVariantEnum.GREEN]: {
    bg: "$primary700",
    iconColor: "$primary600",
    chevronColor: "$white",
    textColor: "$white"
  }
};
